// NationalPartyShareBar.jsx
import { Box } from "@mui/material";
import { PARTY_COLOURS_BY_NAME as PARTY_COLOURS } from "./constants/partyConfig";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  LabelList,
} from "recharts";

// Custom label: party on first line, % on second line (white, centred)
function SegmentLabel({ x, y, width, height, value, name }) {
  // Hide labels if the slice is too thin
  if (width < 20) return null;

  const cx = x + width / 2;
  const cy = y + height / 2;

  const pctText = `${Math.round(value)}%`;

  // If very narrow, only show % to avoid wrapping
  const onlyPct = width < 10;

  return (
    <g style={{ pointerEvents: "none" }}>
      {!onlyPct && (
        <text
          x={cx}
          y={cy - 6}
          textAnchor="middle"
          dominantBaseline="central"
          fill="#fff"
          fontWeight="700"
          fontSize="10"
        >
          {name}
        </text>
      )}
      <text
        x={cx}
        y={onlyPct ? cy : cy + 8}
        textAnchor="middle"
        dominantBaseline="central"
        fill="#fff"
        fontWeight="600"
        fontSize="10"
      >
        {pctText}
      </text>
    </g>
  );
}

export default function NationalPartyShareBar({metricRowsConst, metricRowsNat,selectedFeature,WIDTH,
                latest_wave,filt }) {
    console.log("metricRowsNat",metricRowsNat)
    console.log("selectedFeature",selectedFeature)
    console.log("metricRowsConst",metricRowsConst)
    console.log("latest_wave",latest_wave)
    console.log("filt",filt)

    if(!metricRowsNat){return}
const summariseRows = (rows) => {
    if (!rows?.length) return {};

    const weightKey = "turnout_1_n_sum";
    const predKeys = [
      "act_pred_n",
      "green_pred_n",
      "lab_pred_n",
      "nat_pred_n",
      "nzf_pred_n",
      "oth_pred_n",
      "tpm_pred_n"
    ];

    const totalWeight = rows.reduce(
      (sum, r) => sum + (Number(r[weightKey]) || 0),
      0
    );

    const summary = {
      area_id: rows[0].area_id,
      area_name: rows[0].area_name,
      wave: "summary",
      wave_date: "All waves",
      [weightKey]: totalWeight
    };

    predKeys.forEach((key) => {
      const weightedSum = rows.reduce((sum, r) => {
        const value = Number(r[key]) || 0;
        const weight = Number(r[weightKey]) || 0;
        return sum + value * weight;
      }, 0);

      summary[key] = totalWeight ? weightedSum / totalWeight : 0;
    });

    return summary;
  };

  let row;

 if (filt === "filt") {

  let matchingRows
  

    if (selectedFeature && metricRowsConst) {
      if (metricRowsConst?.length && metricRowsConst[0]?.wave != null) {
            console.log("Filtering");
            matchingRows = metricRowsConst.filter(
              g => Number(g.wave) === Number(latest_wave)
            ) || {};
            console.log("matchingRows", matchingRows);
          } else {
            console.log("no filter");
            matchingRows = metricRowsConst;
            console.log("matchingRows", matchingRows);
          }

          row = summariseRows(matchingRows);
    } else {

   if (metricRowsNat?.length && metricRowsNat[0]?.wave != null) {
            console.log("Filtering");
            row = metricRowsNat.find(
              g => Number(g.wave) === Number(latest_wave)
            ) || {};
          } else {
            console.log("no filter");
            row = metricRowsNat[0] || {};
          }
    }
  } else {
  if(selectedFeature && metricRowsConst){
    
    row = metricRowsConst.filter(
                                (g) => Number(g.area_id) === Number(selectedFeature.area_id) && Number(g.wave) === Number(latest_wave)
                                )[0]

  }else{  
  row = metricRowsNat?.find(g => Number(g.wave) === Number(latest_wave)) || {};
}
  }
  // Helper: convert to 0–100 if values come in 0–1
  const toPct = (v) => {
    if (v == null || Number.isNaN(v)) return 0;
    const num = Number(v);
    return num;
  };
    console.log("row",row)

  // Build a single data point that Recharts will stack into one bar
  const data = [
    {
      id: "NationalRow",
      TPM: toPct(row?.tpm_pred_n),
      Green: toPct(row?.green_pred_n),
      Labour: toPct(row?.lab_pred_n),
      NZF: toPct(row?.nzf_pred_n),
      ACT: toPct(row?.act_pred_n),
      National: toPct(row?.nat_pred_n),
      // OTH: toPct(row.oth_pred_n), // include if you want an Others slice
    },
  ];


  // Ordered left→right to match your screenshot
  const SERIES = ["TPM", "Green", "Labour", "NZF", "ACT", "National"]; // add "OTH" at end if needed

  return (
    <Box sx={{display: "flex",
    justifyContent: "center", // centers horizontally
    alignContent:"center",
    width:WIDTH,
   
    px:0



    }}>
      <ResponsiveContainer width="100%" height={40}
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
          barCategoryGap={0}
        >
          {/* Hide axes but keep domain 0–100 so the bar length reflects % */}
          <XAxis type="number" domain={[0, 100]} hide />
          <YAxis type="category" dataKey="id" hide />

          {SERIES.map((key, idx) => (
            <Bar
              key={key}
              dataKey={key}
              stackId="TOTAL"
              fill={PARTY_COLOURS[key] || "#ccc"}
              stroke="#ffffff"              // thin white separators between slices
              strokeWidth={2}
              radius={
                idx === 0
                  ? [6, 0, 0, 6]           // rounded left end
                  : idx === SERIES.length - 1
                  ? [0, 6, 6, 0]           // rounded right end
                  : [0, 0, 0, 0]
              }
              isAnimationActive={false}     // looks crisper for compact bars
            >
              <LabelList
                dataKey={key}
                content={(props) => (
                  <SegmentLabel {...props} name={key} />
                )}
              />
            </Bar>
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
